import { render, staticRenderFns } from "./nestedProduct.vue?vue&type=template&id=406c1c62&"
import script from "./nestedProduct.vue?vue&type=script&lang=js&"
export * from "./nestedProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports